import React, { useState, useEffect } from 'react';

const LegalPage = () => {
  const [activeSection, setActiveSection] = useState('legal-notice');

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.legal-section');
      const scrollPosition = window.scrollY + 150;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 120;
      const targetPosition = element.offsetTop - offset;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <div className="legal-page">
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .legal-page {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
          background: #f5f7fa;
          color: #1a1a1a;
          line-height: 1.7;
          overflow-x: hidden;
        }

        .nav-header {
          position: sticky;
          top: 0;
          background: rgba(40, 42, 198, 0.98);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          z-index: 1000;
          padding: 1.25rem 0;
          box-shadow: 0 2px 10px rgba(13, 40, 71, 0.3);
        }

        .nav-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
  font-size: 1.5rem;
  color: white;
  font-weight: 600;
  letter-spacing: -0.5px;
}

.logo a {
  color: inherit;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.logo a:hover {
  opacity: 0.9;
}

        .nav-links {
          display: flex;
          gap: 2.5rem;
          list-style: none;
        }

        .nav-links a {
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          font-size: 0.95rem;
          font-weight: 500;
          position: relative;
          transition: color 0.3s ease;
        }

        .nav-links a::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 0;
          height: 2px;
          background: #4a9eff;
          transition: width 0.3s ease;
        }

        .nav-links a:hover {
          color: white;
        }

        .nav-links a:hover::after,
        .nav-links a.active::after {
          width: 100%;
        }

        .hero {
          background: linear-gradient(135deg, #155eb1 0%, #2419bb 50%, #3817ba 100%);
          padding: 5rem 2rem 3rem;
          position: relative;
          overflow: hidden;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 20% 50%, rgba(74, 158, 255, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(74, 158, 255, 0.1) 0%, transparent 50%);
          animation: pulse 8s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }

        .hero-content {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .hero h1 {
          font-size: 3.5rem;
          color: white;
          margin-bottom: 1rem;
          font-weight: 700;
          line-height: 1.1;
        }

        .hero-subtitle {
          font-size: 1.25rem;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 400;
        }

        .content-wrapper {
          max-width: 1400px;
          margin: -2rem auto 0;
          padding: 0 2rem 5rem;
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 3rem;
          position: relative;
          z-index: 2;
        }

        .sidebar {
          position: sticky;
          top: 120px;
          height: fit-content;
          background: #0d2847;
          border-radius: 12px;
          padding: 2rem;
          box-shadow: 0 4px 20px rgba(13, 40, 71, 0.2);
        }

        .sidebar h3 {
          font-size: 0.875rem;
          color: rgba(255, 255, 255, 0.6);
          margin-bottom: 1.5rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .sidebar-nav {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .sidebar-nav button {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.875rem 1rem;
          color: rgba(255, 255, 255, 0.75);
          background: transparent;
          border: none;
          border-radius: 8px;
          transition: all 0.3s ease;
          font-weight: 500;
          font-size: 0.95rem;
          cursor: pointer;
          text-align: left;
          width: 100%;
        }

        .sidebar-nav button::before {
          content: '›';
          font-size: 1.5rem;
          color: #4a9eff;
          transition: transform 0.3s ease;
        }

        .sidebar-nav button:hover {
          background: rgba(74, 158, 255, 0.15);
          color: white;
          transform: translateX(4px);
        }

        .sidebar-nav button:hover::before {
          transform: translateX(4px);
        }

        .sidebar-nav button.active {
          background: #1a3d5f;
          color: white;
          border-left: 3px solid #4a9eff;
        }

        .sidebar-nav button.active::before {
          color: #4a9eff;
        }

        .main-content {
          min-width: 0;
        }

        .legal-section {
          background: white;
          border-radius: 12px;
          padding: 3rem;
          margin-bottom: 2rem;
          box-shadow: 0 2px 12px rgba(13, 40, 71, 0.08);
          border-left: 4px solid #4a9eff;
          scroll-margin-top: 120px;
        }

        .legal-section h2 {
          font-size: 2.5rem;
          color: #0d2847;
          margin-bottom: 0.5rem;
          font-weight: 700;
        }

        .section-meta {
          color: #666;
          font-size: 0.9rem;
          margin-bottom: 2rem;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .legal-section h3 {
          font-size: 1.75rem;
          color: #0d2847;
          margin-top: 2.5rem;
          margin-bottom: 1rem;
          font-weight: 600;
        }

        .legal-section h4 {
          font-size: 1.25rem;
          color: #1a3d5f;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
          font-weight: 600;
        }

        .legal-section h5 {
          font-size: 1rem;
          color: #0d2847;
          margin-bottom: 0.5rem;
          font-weight: 600;
        }

        .legal-section p {
          color: #4a5568;
          margin-bottom: 1rem;
          font-size: 1rem;
        }

        .legal-section ul,
        .legal-section ol {
          margin: 1rem 0 1rem 1.5rem;
          color: #4a5568;
        }

        .legal-section li {
          margin-bottom: 0.5rem;
          padding-left: 0.5rem;
        }

        .highlight-box {
          background: linear-gradient(135deg, rgba(74, 158, 255, 0.1) 0%, rgba(74, 158, 255, 0.05) 100%);
          border-left: 3px solid #4a9eff;
          padding: 1.5rem;
          border-radius: 8px;
          margin: 1.5rem 0;
        }

        .highlight-box strong {
          color: #0d2847;
        }

        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin: 2rem 0;
        }

        .info-card {
          background: #f8fafc;
          padding: 1.5rem;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          transition: all 0.3s ease;
        }

        .info-card:hover {
          border-color: #4a9eff;
          box-shadow: 0 4px 12px rgba(74, 158, 255, 0.15);
          transform: translateY(-2px);
        }

        .info-card h5 {
          color: #0d2847;
          font-weight: 600;
          margin-bottom: 0.5rem;
          font-size: 1rem;
        }

        .info-card p {
          margin: 0;
          font-size: 0.95rem;
        }

        .contact-info {
          background: #0d2847;
          color: white;
          padding: 2rem;
          border-radius: 12px;
          margin: 2rem 0;
        }

        .contact-info h4 {
          color: #4a9eff;
          margin-top: 0;
        }

        .contact-info a {
          color: #4a9eff;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-info a:hover {
          color: #7bb8ff;
          text-decoration: underline;
        }

        .legal-table {
          width: 100%;
          border-collapse: collapse;
          margin: 1.5rem 0;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(13, 40, 71, 0.08);
        }

        .legal-table thead {
          background: #0d2847;
          color: white;
        }

        .legal-table th {
          padding: 1rem;
          text-align: left;
          font-weight: 600;
          font-size: 0.9rem;
        }

        .legal-table td {
          padding: 1rem;
          border-bottom: 1px solid #e5e7eb;
          font-size: 0.95rem;
        }

        .legal-table tbody tr:hover {
          background: #f8fafc;
        }

        .legal-table tbody tr:last-child td {
          border-bottom: none;
        }

        footer {
          background: #0d2847;
          color: rgba(255, 255, 255, 0.8);
          padding: 3rem 2rem 2rem;
          margin-top: 4rem;
        }

        .footer-content {
          max-width: 1400px;
          margin: 0 auto;
          text-align: center;
        }

        .footer-links {
          display: flex;
          justify-content: center;
          gap: 2rem;
          margin-bottom: 1.5rem;
          flex-wrap: wrap;
        }

        .footer-links button {
          color: rgba(255, 255, 255, 0.8);
          background: transparent;
          border: none;
          font-size: 0.9rem;
          transition: color 0.3s ease;
          cursor: pointer;
          padding: 0.25rem 0.5rem;
        }

        .footer-links button:hover {
          color: #4a9eff;
        }

        .copyright {
          font-size: 0.9rem;
          padding-top: 1.5rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .copyright p {
          color: rgba(255, 255, 255, 0.8);
          margin: 0.5rem 0;
        }

        @media (max-width: 968px) {
          .content-wrapper {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .sidebar {
            position: static;
            order: 2;
          }

          .hero h1 {
            font-size: 2.5rem;
          }

          .legal-section {
            padding: 2rem;
          }

          .nav-links {
            display: none;
          }

          .legal-table {
            font-size: 0.85rem;
          }

          .legal-table th,
          .legal-table td {
            padding: 0.75rem 0.5rem;
          }
        }

        html {
          scroll-behavior: smooth;
        }
      `}</style>

      {/* Navigation */}
      <nav className="nav-header">
        <div className="nav-container">
          <div className="logo"><a href="/">ONLINE CREDIT</a></div>
          <ul className="nav-links">
            <li><a href="/">Home</a></li>
            {/* <li><a href="/vergleich">Kreditvergleich</a></li>
            <li><a href="/rechner">Rechner</a></li> */}
            <li><a href="#legal" className="active">Rechtliches</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Rechtliche Informationen</h1>
          <p className="hero-subtitle">Transparenz und Vertrauen durch klare rechtliche Rahmenbedingungen</p>
        </div>
      </section>

      {/* Content Wrapper */}
      <div className="content-wrapper">
        {/* Sidebar Navigation */}
        <aside className="sidebar">
          <h3>LEGAL</h3>
          <ul className="sidebar-nav">
            <li>
              <button
                className={activeSection === 'legal-notice' ? 'active' : ''}
                onClick={() => scrollToSection('legal-notice')}
              >
                Legal Notice
              </button>
            </li>
            <li>
              <button
                className={activeSection === 'terms' ? 'active' : ''}
                onClick={() => scrollToSection('terms')}
              >
                Terms and Conditions
              </button>
            </li>
            <li>
              <button
                className={activeSection === 'privacy' ? 'active' : ''}
                onClick={() => scrollToSection('privacy')}
              >
                Privacy Policy
              </button>
            </li>
            <li>
              <button
                className={activeSection === 'cookies' ? 'active' : ''}
                onClick={() => scrollToSection('cookies')}
              >
                Cookie Policy
              </button>
            </li>
          </ul>
        </aside>

        {/* Main Content */}
        <main className="main-content">
          {/* Impressum Section */}
          <section id="legal-notice" className="legal-section">
            <h2>🇩🇪 Impressum</h2>
            <div className="section-meta">Angaben gemäß § 5 TMG und § 55 RStV</div>

            <div className="highlight-box">
              <p><strong>Wichtiger Hinweis:</strong> Diese Website stellt keine Bank dar und vergibt keine Kredite im eigenen Namen. Wir handeln ausschließlich als Vermittlungsplattform und Informationsdienst.</p>
            </div>

            <h3>Betreiber der Website</h3>
            <div className="info-grid">
              <div className="info-card">
                <h5>Firmenname</h5>
                <p>SchnellerOnlineKredit GmbH</p>
              </div>
              <div className="info-card">
                <h5>Rechtsform</h5>
                <p>Gesellschaft mit beschränkter Haftung</p>
              </div>
              <div className="info-card">
                <h5>Registergericht</h5>
                <p>Amtsgericht Frankfurt am Main</p>
              </div>
              <div className="info-card">
                <h5>Registernummer</h5>
                <p>HRB 123456</p>
              </div>
            </div>

            <h3>Anschrift</h3>
            <p>Finanzstraße 42<br />
            60311 Frankfurt am Main<br />
            Deutschland</p>

            <h3>Kontakt</h3>
            <div className="contact-info">
              <h4>So erreichen Sie uns</h4>
              <p><strong>Telefon:</strong> +49 (0) 15 73230668-0</p>
              <p><strong>Telefax:</strong> +49 (0) 15 73230668-0</p>
              <p><strong>E-Mail:</strong> <a href="mailto:contact@schnelleronlinekredit.de">contact@schnelleronlinekredit.de</a></p>
              <p><strong>Öffnungszeiten:</strong> Mo-Fr 09:00-18:00 Uhr</p>
            </div>

            <h3>Vertretungsberechtigte Geschäftsführer</h3>
            <p>Dr. Michael Weber<br />
            Anna Schmidt</p>

            <h3>Umsatzsteuer-Identifikationsnummer</h3>
            <p>Gemäß § 27a Umsatzsteuergesetz: DE123456789</p>

            <h3>Aufsichtsbehörde</h3>
            <p>Industrie- und Handelskammer Frankfurt am Main<br />
            Börsenplatz 4<br />
            60313 Frankfurt am Main</p>
            <p>Website: <a href="https://www.frankfurt-main.ihk.de" target="_blank" rel="noopener">www.frankfurt-main.ihk.de</a></p>

            <h3>Gewerbliche Tätigkeit</h3>
            <p>Erlaubnis nach § 34c GewO (Kreditvermittlung)<br />
            Erlaubnisbehörde: Stadt Frankfurt am Main, Ordnungsamt<br />
            Register-Nr.: KV-20240123</p>

            <h3>Berufshaftpflichtversicherung</h3>
            <p><strong>Versicherer:</strong> Allianz Versicherungs-AG<br />
            <strong>Geltungsbereich:</strong> Deutschland, EU</p>

            <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
            <p>Dr. Michael Weber<br />
            Finanzstraße 42<br />
            60311 Frankfurt am Main</p>

            <h3>Streitbeilegung</h3>
            <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener">https://ec.europa.eu/consumers/odr</a></p>
            <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </section>

          {/* Terms and Conditions Section */}
          <section id="terms" className="legal-section">
            <h2>🇩🇪 Allgemeine Geschäftsbedingungen (AGB)</h2>
            <div className="section-meta">Stand: Januar 2026</div>

            <h3>1. Geltungsbereich</h3>
            <p>Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung der Website schnelleronlinekredit.de (nachfolgend „Website" oder „Plattform").</p>
            
            <h4>Die Website bietet folgende Online-Dienste:</h4>
            <ul>
              <li>Unabhängiger Kreditvergleich verschiedener Anbieter</li>
              <li>Kreditsimulation und Kreditrechner</li>
              <li>Übermittlung von Kreditanfragen an Partnerinstitute</li>
              <li>Vermittlung zu externen Finanzdienstleistern und Banken</li>
              <li>Informationsdienste rund um Kreditprodukte</li>
            </ul>

            <h3>2. Anbieterstatus und Geschäftsmodell</h3>
            <p>Die Website stellt keine Kredite selbst bereit, sofern nicht ausdrücklich anders angegeben.</p>
            
            <h4>Der Betreiber handelt als:</h4>
            <ul>
              <li><strong>Vermittlungsplattform:</strong> Wir vermitteln Kontakte zwischen Kreditnehmern und Kreditgebern</li>
              <li><strong>Informationsdienst:</strong> Wir stellen Informationen, Vergleiche und Rechner zur Verfügung</li>
              <li><strong>Kreditvermittler:</strong> im Sinne des § 34c Gewerbeordnung (GewO)</li>
            </ul>

            <div className="highlight-box">
              <p><strong>Wichtig:</strong> Die endgültige Kreditentscheidung, einschließlich Bewilligung, Ablehnung und Konditionen, obliegt ausschließlich den jeweiligen Partnerinstituten und Banken. Der Betreiber hat hierauf keinen Einfluss.</p>
            </div>

            <h3>3. Vertragsabschluss und Vertragspartner</h3>
            <p>Durch die Nutzung der Website und die Anfrage eines Kreditvergleichs oder die Übermittlung einer Kreditanfrage kommt <strong>kein Kreditvertrag</strong> zwischen dem Nutzer und dem Betreiber der Website zustande.</p>
            
            <p>Ein Kreditvertrag entsteht ausschließlich zwischen:</p>
            <ul>
              <li>dem Nutzer (Kreditnehmer) und</li>
              <li>dem jeweiligen Kreditinstitut oder der Bank</li>
            </ul>

            <h3>4. Nutzungsvoraussetzungen</h3>
            <p>Mit der Nutzung der Website erklärt der Nutzer verbindlich:</p>
            <ul>
              <li>mindestens 18 Jahre alt zu sein</li>
              <li>voll geschäftsfähig zu sein</li>
              <li>einen Wohnsitz in Deutschland zu haben</li>
              <li>wahrheitsgemäße und vollständige Angaben zu machen</li>
              <li>über ein Konto bei einer deutschen Bank zu verfügen</li>
              <li>nicht in einem laufenden Insolvenzverfahren zu stehen</li>
            </ul>

            <div className="highlight-box">
              <p><strong>Wichtiger Hinweis:</strong> Falschangaben, irreführende Informationen oder die Verschleierung von Tatsachen können zur sofortigen Sperrung des Zugangs führen und haben rechtliche Konsequenzen bei den Partnerbanken.</p>
            </div>

            <h3>5. Pflichten des Nutzers</h3>
            <p>Der Nutzer verpflichtet sich ausdrücklich:</p>
            <ul>
              <li>keine falschen, irreführenden oder unvollständigen Angaben zu machen</li>
              <li>die Website nicht missbräuchlich oder für unrechtmäßige Zwecke zu nutzen</li>
              <li>keine technischen Angriffe durchzuführen (z.B. Hacking, Bots, Scraping, DDoS-Attacken)</li>
              <li>keine automatisierten Systeme zur Datensammlung einzusetzen</li>
              <li>keine Rechte Dritter zu verletzen</li>
            </ul>

            <h3>6. Haftung und Haftungsbeschränkungen</h3>
            <h4>6.1 Keine Haftung für</h4>
            <p>Der Betreiber haftet nicht für:</p>
            <ul>
              <li>Ablehnung von Kreditanträgen durch Partnerbanken</li>
              <li>Konditionen, Zinssätze oder Laufzeiten der Kredite</li>
              <li>Inhalte und Entscheidungen externer Partnerinstitute</li>
              <li>Vorübergehende technische Ausfälle oder Wartungsarbeiten</li>
              <li>Fehlerhafte oder unvollständige Angaben des Nutzers</li>
            </ul>

            <h4>6.2 Haftungsbeschränkung</h4>
            <p>Die Haftung des Betreibers ist beschränkt auf Vorsatz und grobe Fahrlässigkeit, soweit gesetzlich zulässig. Bei leichter Fahrlässigkeit haftet der Betreiber nur bei Verletzung wesentlicher Vertragspflichten.</p>

            <h3>7. Datenschutz (DSGVO-Konformität)</h3>
            <p>Die Verarbeitung personenbezogener Daten erfolgt in strikter Übereinstimmung mit:</p>
            <ul>
              <li>EU-Datenschutz-Grundverordnung (DSGVO – EU 2016/679)</li>
              <li>Bundesdatenschutzgesetz (BDSG)</li>
              <li>Telemediengesetz (TMG)</li>
            </ul>

            <h3>8. Anwendbares Recht und Gerichtsstand</h3>
            <p>Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts (CISG).</p>
            <p>Gerichtsstand ist, soweit gesetzlich zulässig, Frankfurt am Main.</p>

            <h3>9. Kontakt</h3>
            <div className="contact-info">
              <h4>Bei Fragen zu diesen AGB kontaktieren Sie uns:</h4>
              <p><strong>E-Mail:</strong> <a href="mailto:agb@schnelleronlinekredit.de">agb@schnelleronlinekredit.de</a></p>
              <p><strong>Telefon:</strong> +49 (0) 69 1234567-0</p>
            </div>
          </section>

          {/* Privacy Policy Section */}
          <section id="privacy" className="legal-section">
            <h2>🇩🇪 Datenschutzerklärung</h2>
            <div className="section-meta">Stand: Januar 2026 | Gemäß DSGVO (EU 2016/679)</div>

            <div className="highlight-box">
              <p><strong>Ihre Privatsphäre ist uns wichtig.</strong> Diese Datenschutzerklärung informiert Sie umfassend darüber, wie wir Ihre personenbezogenen Daten verarbeiten, welche Rechte Sie haben und wie Sie diese ausüben können.</p>
            </div>

            <h3>1. Verantwortlicher für die Datenverarbeitung</h3>
            <div className="info-card">
              <h5>Verantwortliche Stelle gemäß Art. 4 Nr. 7 DSGVO:</h5>
              <p>SchnellerOnlineKredit GmbH<br />
              Finanzstraße 42<br />
              60311 Frankfurt am Main<br />
              Deutschland</p>
              <p><strong>Telefon:</strong> +49 (0) 69 1234567-0<br />
              <strong>E-Mail:</strong> datenschutz@schnelleronlinekredit.de</p>
            </div>

            <h3>2. Datenschutzbeauftragter</h3>
            <p>Unseren betrieblichen Datenschutzbeauftragten erreichen Sie unter:</p>
            <div className="info-card">
              <h5>Datenschutzbeauftragter</h5>
              <p>Dr. Julia Schneider<br />
              SchnellerOnlineKredit GmbH</p>
              <p><strong>E-Mail:</strong> dsb@schnelleronlinekredit.de</p>
            </div>

            <h3>3. Umfang der Datenverarbeitung</h3>
            <p>Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website erforderlich ist.</p>

            <h4>3.1 Rechtsgrundlagen</h4>
            <ul>
              <li><strong>Art. 6 Abs. 1 lit. a DSGVO:</strong> Einwilligung der betroffenen Person</li>
              <li><strong>Art. 6 Abs. 1 lit. b DSGVO:</strong> Verarbeitung zur Vertragserfüllung</li>
              <li><strong>Art. 6 Abs. 1 lit. c DSGVO:</strong> Erfüllung rechtlicher Verpflichtungen</li>
              <li><strong>Art. 6 Abs. 1 lit. f DSGVO:</strong> Wahrung berechtigter Interessen</li>
            </ul>

            <h3>4. Erhobene Daten bei Kreditanfrage</h3>
            <h4>Persönliche Angaben:</h4>
            <ul>
              <li>Vor- und Nachname</li>
              <li>Geburtsdatum und Geburtsort</li>
              <li>Anschrift (Straße, PLZ, Ort)</li>
              <li>E-Mail-Adresse und Telefonnummer</li>
              <li>Staatsangehörigkeit</li>
            </ul>

            <h4>Finanzielle Angaben:</h4>
            <ul>
              <li>Beschäftigungsverhältnis und Arbeitgeber</li>
              <li>Monatliches Nettoeinkommen</li>
              <li>Bestehende Kredite und Verbindlichkeiten</li>
              <li>Wohnverhältnis (Miete/Eigentum)</li>
            </ul>

            <h3>5. Cookies und Tracking</h3>
            <p>Diese Website verwendet Cookies zur Verbesserung der Nutzererfahrung. Details finden Sie in unserer Cookie-Richtlinie.</p>

            <h3>6. Ihre Rechte als betroffene Person</h3>
            <div className="info-grid">
              <div className="info-card">
                <h5>Auskunftsrecht (Art. 15 DSGVO)</h5>
                <p>Recht auf Auskunft über gespeicherte Daten</p>
              </div>
              <div className="info-card">
                <h5>Berichtigungsrecht (Art. 16 DSGVO)</h5>
                <p>Recht auf Korrektur falscher Daten</p>
              </div>
              <div className="info-card">
                <h5>Löschungsrecht (Art. 17 DSGVO)</h5>
                <p>Recht auf Löschung personenbezogener Daten</p>
              </div>
              <div className="info-card">
                <h5>Widerspruchsrecht (Art. 21 DSGVO)</h5>
                <p>Recht auf Widerspruch gegen Verarbeitung</p>
              </div>
            </div>

            <h3>7. Kontakt Datenschutz</h3>
            <div className="contact-info">
              <h4>Datenschutz-Kontakt</h4>
              <p><strong>E-Mail:</strong> <a href="mailto:datenschutz@schnelleronlinekredit.de">datenschutz@schnelleronlinekredit.de</a></p>
              <p><strong>Telefon:</strong> +49 (0) 69 1234567-50</p>
            </div>

            <h3>8. Datensicherheit</h3>
            <p>Wir setzen umfassende Sicherheitsmaßnahmen ein:</p>
            <ul>
              <li><strong>SSL/TLS-Verschlüsselung:</strong> Alle Datenübertragungen sind verschlüsselt</li>
              <li><strong>Firewalls:</strong> Schutz vor unbefugtem Zugriff</li>
              <li><strong>Zugriffskontrollen:</strong> Nur autorisierte Mitarbeiter haben Zugang</li>
              <li><strong>Regelmäßige Backups:</strong> Sicherung gegen Datenverlust</li>
              <li><strong>ISO 27001 zertifizierte Rechenzentren</strong></li>
            </ul>
          </section>

          {/* Cookie Policy Section */}
          <section id="cookies" className="legal-section">
            <h2>🍪 Cookie-Richtlinie</h2>
            <div className="section-meta">Stand: Januar 2026 | Gemäß § 25 TTDSG und ePrivacy-Richtlinie</div>

            <h3>1. Was sind Cookies?</h3>
            <p>Cookies sind kleine Textdateien, die von Ihrem Webbrowser auf Ihrem Endgerät gespeichert werden. Sie enthalten Informationen, die bei späteren Besuchen ausgelesen werden können.</p>

            <h3>2. Arten von Cookies</h3>
            <div className="info-grid">
              <div className="info-card">
                <h5>🔧 Technisch notwendige Cookies</h5>
                <p><strong>Zweck:</strong> Grundfunktionen der Website</p>
                <p><strong>Einwilligung:</strong> Nicht erforderlich</p>
              </div>
              <div className="info-card">
                <h5>📊 Analyse-Cookies</h5>
                <p><strong>Zweck:</strong> Statistiken und Optimierung</p>
                <p><strong>Einwilligung:</strong> Erforderlich</p>
              </div>
              <div className="info-card">
                <h5>🎯 Marketing-Cookies</h5>
                <p><strong>Zweck:</strong> Personalisierte Werbung</p>
                <p><strong>Einwilligung:</strong> Erforderlich</p>
              </div>
              <div className="info-card">
                <h5>⚙️ Funktionale Cookies</h5>
                <p><strong>Zweck:</strong> Erweiterte Funktionen</p>
                <p><strong>Einwilligung:</strong> Erforderlich</p>
              </div>
            </div>

            <h3>3. Detaillierte Cookie-Übersicht</h3>
            <h4>3.1 Technisch notwendige Cookies</h4>
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Cookie-Name</th>
                  <th>Zweck</th>
                  <th>Speicherdauer</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>session_id</td>
                  <td>Eindeutige Identifikation der Sitzung</td>
                  <td>Session</td>
                </tr>
                <tr>
                  <td>cookie_consent</td>
                  <td>Speicherung Ihrer Cookie-Präferenzen</td>
                  <td>1 Jahr</td>
                </tr>
                <tr>
                  <td>csrf_token</td>
                  <td>Schutz vor Cross-Site-Request-Forgery</td>
                  <td>Session</td>
                </tr>
                <tr>
                  <td>language</td>
                  <td>Speicherung der Spracheinstellung</td>
                  <td>30 Tage</td>
                </tr>
              </tbody>
            </table>

            <h4>3.2 Analyse-Cookies (Google Analytics)</h4>
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Cookie-Name</th>
                  <th>Zweck</th>
                  <th>Speicherdauer</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>_ga</td>
                  <td>Unterscheidung von Benutzern</td>
                  <td>2 Jahre</td>
                </tr>
                <tr>
                  <td>_gid</td>
                  <td>Unterscheidung von Benutzern</td>
                  <td>24 Stunden</td>
                </tr>
                <tr>
                  <td>_gat</td>
                  <td>Drosselung der Anfragerate</td>
                  <td>1 Minute</td>
                </tr>
              </tbody>
            </table>

            <h4>3.3 Marketing-Cookies</h4>
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Cookie-Name</th>
                  <th>Anbieter</th>
                  <th>Zweck</th>
                  <th>Speicherdauer</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>_fbp</td>
                  <td>Facebook</td>
                  <td>Tracking für Facebook-Werbung</td>
                  <td>3 Monate</td>
                </tr>
                <tr>
                  <td>fr</td>
                  <td>Facebook</td>
                  <td>Personalisierte Werbung</td>
                  <td>3 Monate</td>
                </tr>
                <tr>
                  <td>IDE</td>
                  <td>Google</td>
                  <td>Anzeigen-Targeting</td>
                  <td>1 Jahr</td>
                </tr>
              </tbody>
            </table>

            <h3>4. Cookie-Einstellungen verwalten</h3>
            <div className="highlight-box">
              <p><strong>Ihre Einstellungen ändern:</strong> Sie können Ihre Cookie-Präferenzen jederzeit anpassen, indem Sie auf den "Cookie-Einstellungen"-Link im Footer klicken.</p>
            </div>

            <h4>Browser-Einstellungen</h4>
            <p>Alternativ können Sie Cookies direkt in Ihrem Browser verwalten:</p>
            <ul>
              <li><strong>Chrome:</strong> Einstellungen → Datenschutz und Sicherheit → Cookies</li>
              <li><strong>Firefox:</strong> Einstellungen → Datenschutz & Sicherheit</li>
              <li><strong>Safari:</strong> Einstellungen → Datenschutz</li>
              <li><strong>Edge:</strong> Einstellungen → Cookies und Websiteberechtigungen</li>
            </ul>

            <h3>5. Cookies von Drittanbietern</h3>
            <p>Wir nutzen Dienste von Drittanbietern:</p>
            <ul>
              <li><strong>Google Analytics:</strong> Webanalyse - <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Datenschutz</a></li>
              <li><strong>Facebook Pixel:</strong> Conversion-Tracking - <a href="https://www.facebook.com/privacy" target="_blank" rel="noopener">Datenschutz</a></li>
            </ul>

            <h3>6. Kontakt bei Fragen zu Cookies</h3>
            <div className="contact-info">
              <h4>Cookie-Fragen und Datenschutz</h4>
              <p><strong>E-Mail:</strong> <a href="mailto:cookies@schnelleronlinekredit.de">cookies@schnelleronlinekredit.de</a></p>
              <p><strong>Telefon:</strong> +49 (0) 69 1234567-50</p>
            </div>
          </section>
        </main>
      </div>

     
    </div>
  );
};

export default LegalPage;